import React, { FC } from 'react';
import LockIcon from '@/components/LockIcon';
import { TPasscodeVariant } from '../PasscodeKeypad';

export interface IPasscodeHeaderProps {
  isLocked?: boolean;
  title?: string;
  variant?: TPasscodeVariant;
}

const PasscodeHeader: FC<IPasscodeHeaderProps> = ({
  isLocked,
  title,
  variant,
}) => (
  <>
    <LockIcon isLocked={isLocked} variant={variant} />
    {!!title && (
      <div className="text-sm font-demibold text-gray-120">{title}</div>
    )}
  </>
);

export default PasscodeHeader;
